import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressHelperService {
public eventHelper = new Subject<{prev:boolean, next:boolean}>();
  // BehaviorSubject replays the last width to any late subscriber (e.g. child tabs that subscribe after ngAfterViewInit has already emitted)
  actWidth = new BehaviorSubject<number>(0);
  constructor() { }
}
